import { AvtGateway, HttpRequest } from '../../../kernel/avt.gateway'
import { MultistopRepository } from '../domain/multistop.repository'

export const odinNebulaMultistopRepository: MultistopRepository = {
  create: async (jobUuid, body) => {
    const request: HttpRequest = {
      method: 'POST',
      endpoint: `/nebula/jobs/${jobUuid}/stops`,
      body
    }

    await AvtGateway.executePostRequest(request)
  },
  moveItems: async (jobUuid, body) => {
    const request: HttpRequest = {
      method: 'PATCH',
      endpoint: `/nebula/jobs/${jobUuid}/stops/items`,
      body
    }

    await AvtGateway.executePatchRequest(request)
  },
  delete: async (jobUuid, body) => {
    const request: HttpRequest = {
      method: 'DELETE',
      endpoint: `/nebula/jobs/${jobUuid}/stops`,
      body
    }

    await AvtGateway.executeDeleteRequest(request)
  }
}
